import { LOGIN, CHECK, CHECK_PASSED, LOGOUT } from '@/state/types/auth'

export const userLogin = (payload, pathName) => ({
  type: LOGIN,
  payload,
  meta: { auth: true, pathName },
})

export const userCheck = (payload, pathName) => ({
  type: CHECK,
  payload,
  meta: { auth: true, pathName },
})

export const userLogout = () => ({
  type: LOGOUT,
  meta: { auth: true },
})

export const userAuthenticated = () => ({
  type: CHECK_PASSED,
})



// WEBPACK FOOTER //
// ./state/actions/auth.js